<!--
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-09 18:29:05
 * @LastEditors: yangyi yangyi@caohua.com
 * @LastEditTime: 2026-06-08 16:56:50
 * @FilePath: \tiangong\src\views\tools\dmp\autoUpload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="auto-upload">
    <div class="upload-hd">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElSelect
            v-model="accountId"
            style="width: 220px"
            filterable
            @change="handleGame"
            :loading="selectLoading"
            placeholder="请选择账号"
          >
            <el-option v-for="(item, index) in accountData" :key="index" :label="item.newLabel" :value="item.id"> </el-option>
          </ElSelect>
        </ElFormItem>
        <Button type="primary" @click="addAccount">添加账号</Button>
        <p>注意：建议每个媒体和主体只添加一个主账号，这样子能减少处理时间</p>
      </ElForm>
    </div>
    <div class="upload-bd">
      <el-table
        :data="tableData"
        class="common-el-table-styles"
        border
        v-loading="loading"
        height="calc(100vh - 260px)"
        style="width: 100%"
      >
        <el-table-column prop="accountId" label="账号ID"> </el-table-column>
        <el-table-column prop="adAccount" label="账号名称"> </el-table-column>
        <el-table-column prop="advertiserId" label="计划主ID"> </el-table-column>
        <el-table-column prop="mediaName" label="媒体"> </el-table-column>
        <el-table-column prop="advertiserCompanyName" label="开户主体"> </el-table-column>
        <el-table-column prop="creator" label="创建人"> </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="{ row }">
            {{ row.createTime | datetimeToSec }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <Poptip confirm transfer title="确定要删除该账号吗？" @on-ok="dele(row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { autoAcConfAdd, autoAcConfDel, autoAcConfPageList, autoAcConfGetMediaAccountList } from '@/api/manage.model'
export default {
  name: 'autoUpload',
  data() {
    return {
      selectLoading: false,
      accountId: '',
      accountData: [],
      loading: false,
      tableData: []
    }
  },
  created() {
    this.getData()
    this.getSelectList()
  },
  methods: {
    getData() {
      this.loading = true
      autoAcConfPageList().then((data) => {
        if (data) {
          this.tableData = data
        }
        this.loading = false
        // this.total = data.page_info && data.page_info.total_number
      })
    },
    getSelectList() {
      this.selectLoading = true
      autoAcConfGetMediaAccountList().then((data) => {
        this.accountData = data
        this.selectLoading = false
        this.accountData.forEach((item) => {
          item.newLabel = item.adAccount + ' (' + item.mediaName + ')'
        })
      })
    },
    handleGame(meta) {
      this.accountId = meta
    },
    addAccount() {
      let params = {}
      this.accountData.forEach((item) => {
        if (this.accountId === item.id) {
          params = {
            accountId: item.id,
            advertiserId: item.advertiserId,
            mediaId: item.mediaId,
            companyId: item.companyId
          }
        }
      })
      autoAcConfAdd(params).then((data) => {
        if (data) {
          this.$Message.success('添加成功')
          this.pageIndex = 1
          this.getData()
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.pageSize = size
      this.getData()
    },
    dele(item) {
      autoAcConfDel({
        id: item.id
      }).then((data) => {
        this.getData()
      })
    }
  }
}
</script>
<style lang="scss">
.upload-hd {
  padding: 10px 0 12px;
  overflow: hidden;
  p {
    padding-top: 8px;
    color: #ff6400;
  }
}
.c-table-page {
  margin: 10px 0 !important;
  padding: 0 8px;
  text-align: right;
}
</style>
